





import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "BaseButtonCreate",
  components: { BaseButton, BaseIcon },
});
